/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var I18nManager = {
  allowRTL() {
    return;
  },

  forceRTL() {
    return;
  },

  getConstants() {
    return {
      isRTL: false
    };
  }

};
export default I18nManager;